import { requestData } from "@/api/api-config";

export type PylonIdentity = { email: string; emailHash: string };

export async function fetchPylonIdentity(): Promise<PylonIdentity> {
  const result = await requestData<PylonIdentity>(
    "user/pylon-hash",
    "get",
    undefined,
    false,
  );
  if (!result?.email || !result.emailHash) {
    throw new Error("pylon-hash response missing email or emailHash");
  }
  return result;
}
